"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomFunctionAdapter = void 0;
const AdapterBase_1 = require("../../storyV2/adapter/AdapterBase");
const Story_1 = require("../../storyV2/domain/Story");
const StoryEdgeOptionsUtil_1 = require("../../storyV2/domain/StoryEdgeOptionsUtil");
const StoryNode_1 = require("../../storyV2/domain/StoryNode");
const FunctionBase_1 = require("../../storyV2/function/FunctionBase");
const FunctionUtil_1 = require("../../storyV2/function/FunctionUtil");
const StoryEdge_1 = require("../../storyV2/domain/StoryEdge");
const StudioProjectAttributesV2Edge_1 = require("../../project/domain/StudioProjectAttributesV2Edge");
const ImageModel_1 = require("../../storyV2/model/ImageModel");
const StoryNodeOptions_1 = require("../../storyV2/domain/StoryNodeOptions");
const StoryNodeType_1 = require("../../storyV2/domain/StoryNodeType");
const StoryNodeDisplayType_1 = require("../../storyV2/domain/StoryNodeDisplayType");
const StoryNodeOptionsUtil_1 = __importDefault(require("../../storyV2/domain/StoryNodeOptionsUtil"));
const AdapterResponseUtil_1 = require("../../storyV2/adapter/AdapterResponseUtil");
const LangUtil_1 = require("../../cutil/LangUtil");
const Eventbus_1 = require("../../cutil/Eventbus");
const RunCustomFunctionMsg_1 = require("../../msg/RunCustomFunctionMsg");
class CustomFunctionAdapter extends AdapterBase_1.CustomAdapterBase {
    dynamicRunResponseType() {
        if (this.lastResType) {
            const resType = AdapterResponseUtil_1.AdapterResponseUtil.responseTypeTransform(this.lastResType);
            if (resType === AdapterBase_1.RunResponseType.STREAM) {
                return AdapterBase_1.RunResponseType.TEXT;
            }
            return resType;
        }
        return AdapterBase_1.RunResponseType.TEXT;
    }
    async run(story, edge, sourceNode, actionData) {
        const customFuncDest = this.customFuncDest;
        if (customFuncDest) {
            const streamResponse = await this.runSubStory(story, edge, customFuncDest);
            return Promise.resolve(new AdapterBase_1.RunResponse(AdapterBase_1.RunResponseType.CUSTOM_FUNCTION, streamResponse));
        }
        return super.run(story, edge, sourceNode, actionData);
    }
    async runNode(node, actionData, story, edge) {
        if (node === undefined) {
            return Promise.reject();
        }
        const input = node.content;
        let edgeArr = [];
        if (this.customFuncDest?.isV3Function === true) {
            const dataArr = this.customFuncDest?.nodeArr
                ?.map(n => n.data)
                .filter(d => {
                return d instanceof StudioProjectAttributesV2Edge_1.StudioProjectAttributesV2EdgeData;
            });
            edgeArr = dataArr.map(d => {
                const edge = new StudioProjectAttributesV2Edge_1.StudioProjectAttributesV2Edge();
                edge.data = d;
                return edge;
            });
        }
        else {
            edgeArr = this.customFuncDest?.edgeArr || [];
        }
        const actionDatas = edgeArr.map(element => {
            const action = StoryEdgeOptionsUtil_1.StoryEdgeOptionsUtil.from(element).actionData;
            return action;
        });
        const sourceNodes = [];
        edgeArr.forEach((value, index, array) => {
            if (index === 0) {
                sourceNodes.push(node);
            }
            return CustomFunctionUtil.findNode(value, this.customFuncDest);
        });
        if (actionDatas === undefined) {
            return Promise.reject();
        }
        const res = await this.runAll(actionDatas, sourceNodes, 0, story, edge, input);
        return res;
    }
    /**
     * 当前是v3版本，那么将当前customFunction 组装成一个SubStory去调用
     * @param story
     * @param edge
     * @param customFuncDest
     */
    runSubStory(story, edge, customFuncDest) {
        /**
         * 这个stream只会返回两次
         * 1 运行到最后一条边，并且已经产生了targetNode
         * 2 最后一条边已经运行结束
         */
        const stremResponse = new FunctionBase_1.RunStreamResponse();
        const msg = new RunCustomFunctionMsg_1.RunCustomFunctionMsg(story, edge, customFuncDest, (resultNode, newStory, error) => {
            if (resultNode instanceof StoryNode_1.StoryNode && newStory instanceof Story_1.Story) {
                stremResponse.receive(resultNode, true);
            }
            else if (error) {
                stremResponse.receive(undefined, true, error);
            }
        }, newTargetNode => {
            stremResponse.receive(newTargetNode, false);
        });
        Eventbus_1.eventbus.emit(msg);
        return Promise.resolve(stremResponse);
    }
    async runAll(actionDatas, sourceNodes, runIndex, story, edge, input) {
        if (runIndex >= actionDatas.length) {
            return input;
        }
        const actionData = actionDatas[runIndex];
        const sourceNode = sourceNodes[runIndex];
        let res;
        if (typeof input === "string") {
            res = await this.runByActionData(actionData, sourceNode, story, edge, input);
        }
        else {
            let inputs = [];
            if (Array.isArray(input)) {
                inputs = [...input];
            }
            else if (input instanceof FunctionBase_1.RunStreamResponse) {
                // TODO: 提取值到数组作为下一个 function 的输入
            }
            const customStreamResponse = {
                values: inputs,
                streamResponse: new FunctionBase_1.RunStreamResponse(),
            };
            const map = new Map();
            const requestArr = inputs.map((input, index) => {
                const request = this.runByActionData(actionData, sourceNode, story, edge, input)
                    .then(res => {
                    map.set(index, new LangUtil_1.TryResult(res, undefined));
                    let completion = false;
                    if (map.size === inputs.length) {
                        completion = true;
                    }
                    customStreamResponse.streamResponse.receive(map, completion);
                    return Promise.resolve();
                })
                    .catch(error => {
                    map.set(index, new LangUtil_1.TryResult(undefined, error));
                    let completion = false;
                    if (map.size === inputs.length) {
                        completion = true;
                    }
                    customStreamResponse.streamResponse.receive(map, completion);
                    return Promise.resolve();
                });
                return request;
            });
            await Promise.all(requestArr);
            res = customStreamResponse;
        }
        return this.runAll(actionDatas, sourceNodes, runIndex + 1, story, edge, res);
    }
    async runByActionData(actionData, sourceNode, story, edge, input) {
        const res = await FunctionUtil_1.FunctionUtil.findFuncAndRun(input, actionData, this.funcRegistry, FunctionUtil_1.FunctionUtil.createFuncVariables(story, edge), { projectId: story.projectId, edgeId: edge.options.id, fromCustomFunction: true }, () => edge.state === StoryEdge_1.EdgeState.ERROR, sourceNode);
        this.lastResType = res.type;
        switch (res.type) {
            case FunctionBase_1.FuncResponseType.STREAM_TEXT:
                const streamResponse = res.data;
                return new Promise(executor => {
                    streamResponse.onReceived(result => {
                        if (result.completion) {
                            executor(result.value);
                        }
                    });
                });
            case FunctionBase_1.FuncResponseType.IMAGE_TEXT:
                return new ImageModel_1.ImageModel(input, res.data, res.data);
            default:
                return res.data;
        }
    }
}
exports.CustomFunctionAdapter = CustomFunctionAdapter;
class CustomFunctionUtil {
    static findNode(edgeModel, dest) {
        if (!dest) {
            return this.createDefaultNode();
        }
        const sourceNodeId = edgeModel.data?.flows?.first()?.sourceNodeId || "";
        if (sourceNodeId === "") {
            return this.createDefaultNode();
        }
        const sourceNodeData = dest.nodeArr?.find(n => {
            return n.id === sourceNodeId;
        });
        if (!sourceNodeData) {
            return this.createDefaultNode();
        }
        const nodeOption = StoryNodeOptionsUtil_1.default.from(sourceNodeData);
        const node = new StoryNode_1.StoryNode(nodeOption);
        return node;
    }
    static createDefaultNode() {
        const defaultNodeOption = new StoryNodeOptions_1.StoryNodeOptions("", "", StoryNodeType_1.StoryNodeType.CUSTOMNODE, StoryNodeDisplayType_1.StoryNodeDisplayType.TEXT);
        const defaultNode = new StoryNode_1.StoryNode(defaultNodeOption);
        return defaultNode;
    }
}
